// ════════════════════════════════════════════════════════
//  FAYE STUDIOS — global theme scripts
//  Popup removed (handled by Omnisend). All URLs use Shopify paths.
// ════════════════════════════════════════════════════════

// ── BLOCK 1: overlays, drawer, nav scroll ──
(function () {

    // ── Lifestyle overlay tracking (homepage) ──
    function updateOverlays() {
        if (window.innerWidth <= 768) return; // mobile handled by CSS
        const viewH = window.innerHeight;
        const TOP_GAP = 24;

        const allSections = [
            ...document.querySelectorAll('.lifestyle-section'),
            ...document.querySelectorAll('.hero-section')
        ];
        allSections.forEach(section => {
            const overlay = section.querySelector('.lifestyle-overlay') || section.querySelector('.hero-overlay');
            if (!overlay) return;

            const BOTTOM_GAP = parseInt(section.dataset.gap ?? 28);
            const LEFT = parseInt(section.dataset.left ?? 28);

            const rect = section.getBoundingClientRect();
            const sectionH = section.offsetHeight;
            const overlayH = overlay.offsetHeight;

            if (sectionH < 50) return;

            const idealTop = viewH - rect.top - BOTTOM_GAP - overlayH;
            const minTop = TOP_GAP;
            const maxTop = sectionH - overlayH - BOTTOM_GAP;

            if (idealTop >= minTop && idealTop <= maxTop) {
                overlay.style.position = 'fixed';
                overlay.style.top = 'auto';
                overlay.style.bottom = BOTTOM_GAP + 'px';
                overlay.style.left = LEFT + 'px';
            } else {
                const clampedTop = Math.max(minTop, Math.min(maxTop, idealTop));
                overlay.style.position = 'absolute';
                overlay.style.bottom = 'auto';
                overlay.style.top = clampedTop + 'px';
                overlay.style.left = LEFT + 'px';
            }
        });
    }

    // ── Mobile nav drawer ──
    window.openDrawer = function () {
        const drawer = document.getElementById('mobile-drawer');
        if (!drawer) return;
        drawer.style.display = 'block';
    };
    window.closeDrawer = function () {
        const drawer = document.getElementById('mobile-drawer');
        if (!drawer) return;
        drawer.style.display = 'none';
    };

    // ── Nav + marquee: marquee scrolls away, nav locks to top ──
    let lastScrollY = window.scrollY;
    function updateNav() {
        const nav = document.querySelector('.top-nav');
        const marquee = document.querySelector('.marquee-track')?.parentElement;
        if (!nav) return;
        const scrollY = window.scrollY;
        const marqueeHeight = marquee ? marquee.offsetHeight : 28;

        // Slide marquee up and out as you scroll past it
        if (marquee) {
            const shift = Math.min(scrollY, marqueeHeight);
            marquee.style.transform = 'translateY(-' + shift + 'px)';
        }

        // Nav sits below marquee, then locks to top
        nav.style.top = Math.max(0, marqueeHeight - scrollY) + 'px';

        // Color logic — solid once past hero, transparent over it
        const hero = document.querySelector('.hero-section, .collection-video-hero');
        const heroBottom = hero ? hero.offsetTop + hero.offsetHeight : 0;

        if (!hero) {
            nav.classList.add('nav-solid');
        } else if (scrollY <= 10) {
            nav.classList.remove('nav-solid');
        } else if (scrollY >= heroBottom) {
            nav.classList.add('nav-solid');
        } else if (scrollY < lastScrollY) {
            nav.classList.add('nav-solid');
        } else {
            nav.classList.remove('nav-solid');
        }
        lastScrollY = scrollY;
    }
    window.addEventListener('scroll', updateNav, { passive: true });
    updateNav();

    window.addEventListener('scroll', updateOverlays, { passive: true });
    window.addEventListener('resize', updateOverlays);
    window.addEventListener('load', updateOverlays);
    updateOverlays();

})();


// ── BLOCK 2: footer reveal ──
(function () {
    var footer = document.querySelector('footer');
    var wrap = document.querySelector('.page-wrap');
    if (!footer) return;
    function update() {
        if (window.innerWidth <= 768) {
            footer.style.transform = '';
            if (wrap) wrap.style.marginBottom = '';
            return;
        }
        var fh = footer.offsetHeight;
        if (wrap) wrap.style.marginBottom = fh + 'px';
        var scrollBottom = window.scrollY + window.innerHeight;
        var docHeight = document.body.scrollHeight;
        var progress = (scrollBottom - (docHeight - fh)) / fh;
        progress = Math.max(0, Math.min(1, progress));
        footer.style.transform = 'translateY(' + ((1 - progress) * 100) + '%)';
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', function () { update(); });
    update();

    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { update(); });
    }
})();


// ── BLOCK 3: shop dropdown ──
(function () {
    var wrap = document.querySelector('.nav-shop-wrap');
    if (!wrap) return;
    var dd = wrap.querySelector('.nav-shop-dropdown');
    var nav = document.querySelector('.top-nav');
    var t;
    function pos() { if (nav) { var r = nav.getBoundingClientRect(); dd.style.top = r.bottom + 'px'; } }
    function show() { clearTimeout(t); pos(); dd.style.opacity = '1'; dd.style.pointerEvents = 'auto'; if (nav) { nav.classList.add('nav-solid'); nav.classList.add('nav-dd-open'); } }
    function hide() { t = setTimeout(function () { dd.style.opacity = '0'; dd.style.pointerEvents = 'none'; nav.classList.remove('nav-dd-open'); if (nav && window.scrollY <= 10) nav.classList.remove('nav-solid'); }, 100); }
    wrap.addEventListener('mouseenter', show);
    wrap.addEventListener('mouseleave', hide);
    dd.addEventListener('mouseenter', function () { clearTimeout(t); });
    dd.addEventListener('mouseleave', hide);
})();


// ── BLOCK 4: search ──
(function () {
    var searchData = [
        { name: 'FF Tee Navy Blue', type: 'Tees', url: '/products/ff-tee-navy', tags: 'tee tshirt shirt navy blue dark ff top' },
        { name: 'FF Tee Light Blue', type: 'Tees', url: '/products/ff-tee-light-blue', tags: 'tee tshirt shirt light blue baby ff top' },
        { name: 'FY Sweatpants Real Tree', type: 'Sweatpants', url: '/products/fy-camo-sweats', tags: 'sweatpants sweats camo camouflage real tree realtree fy pants bottoms' },
        { name: 'FY Low Rise Sweatpants Grey White', type: 'Sweatpants', url: '/products/grey-sweats', tags: 'sweatpants sweats grey gray white fy low rise pants bottoms' },
        { name: 'FY Bird Hoodie Real Tree', type: 'Hoodies', url: '/products/fy-camo-hoodie', tags: 'hoodie hoodies camo camouflage real tree realtree bird fy' },
        { name: 'FY Bird Hoodie Cream Blue', type: 'Hoodies', url: '/products/fy-bird-hoodie-cream-blue', tags: 'hoodie hoodies cream blue white bird fy' },
        { name: '99 Hoodie Blue White', type: 'Hoodies', url: '/products/99-hoodie-blue', tags: 'hoodie hoodies 99 blue white' },
        { name: '99 Hoodie Grey White', type: 'Hoodies', url: '/products/99-hoodie-grey', tags: 'hoodie hoodies 99 grey gray white' },
        { name: 'Tees', type: 'Category', url: '/collections/tees', tags: 'tees tee tshirt shirt top' },
        { name: 'Hoodies', type: 'Category', url: '/collections/hoodies', tags: 'hoodies hoodie' },
        { name: 'Sweatpants', type: 'Category', url: '/collections/sweats', tags: 'sweatpants sweats pants bottoms' },
        { name: 'New Arrivals', type: 'Collection', url: '/collections/new-arrivals', tags: 'new arrivals new in latest fresh' },
        { name: 'Shop All', type: 'Collection', url: '/collections/all', tags: 'shop all everything' },
    ];

    window.openMobileSearch = function () {
        document.getElementById('mobile-search-overlay').classList.add('mso-open');
        document.body.style.overflow = 'hidden';
        setTimeout(function () { document.getElementById('mso-input').focus(); }, 80);
    };
    window.closeMobileSearch = function () {
        document.getElementById('mobile-search-overlay').classList.remove('mso-open');
        document.body.style.overflow = '';
        document.getElementById('mso-input').value = '';
        resetMsoResults();
    };
    function resetMsoResults() {
        document.getElementById('mso-results').innerHTML = '<div class="mso-suggestions"><div class="mso-sug-label">Browse</div><div class="mso-sug-chips"><a href="/collections/new-arrivals" class="mso-chip">New Arrivals</a><a href="/collections/tees" class="mso-chip">Tees</a><a href="/collections/hoodies" class="mso-chip">Hoodies</a><a href="/collections/sweats" class="mso-chip">Sweatpants</a></div></div>';
    }
    window.runMobileSearch = function (val) {
        var r = document.getElementById('mso-results');
        if (!val.trim()) { resetMsoResults(); return; }
        var q = val.toLowerCase();
        var matches = searchData.filter(function (d) {
            return d.name.toLowerCase().indexOf(q) > -1 || d.tags.toLowerCase().indexOf(q) > -1;
        }).slice(0, 10);
        if (!matches.length) {
            r.innerHTML = '<div class="mso-empty">No results for &ldquo;' + val + '&rdquo;</div>';
        } else {
            r.innerHTML = matches.map(function (d) {
                return '<a href="' + d.url + '" class="mso-item"><span class="mso-item-name">' + d.name + '</span><span class="mso-item-type">' + d.type + '</span></a>';
            }).join('');
        }
    };
    window.msoKey = function (e) {
        if (e.key === 'Escape') closeMobileSearch();
        if (e.key === 'Enter') {
            var q = e.target.value.trim();
            if (!q) return;
            var match = searchData.find(function (d) {
                return d.name.toLowerCase().indexOf(q.toLowerCase()) > -1 || d.tags.toLowerCase().indexOf(q.toLowerCase()) > -1;
            });
            if (match) window.location.href = match.url;
        }
    };
    window.runNavSearch = function (val) {
        var r = document.getElementById('nav-search-results');
        if (!val.trim()) { r.classList.remove('nsr-visible'); r.innerHTML = ''; return; }
        var q = val.toLowerCase();
        var matches = searchData.filter(function (d) {
            return d.name.toLowerCase().indexOf(q) > -1 || d.tags.toLowerCase().indexOf(q) > -1;
        }).slice(0, 7);
        if (!matches.length) {
            r.innerHTML = '<div style="padding:14px;font-size:12px;color:#aaa;letter-spacing:-0.02em;">No results found</div>';
        } else {
            r.innerHTML = matches.map(function (d) {
                return '<a href="' + d.url + '" class="nsr-item"><span style="font-weight:500;">' + d.name + '</span><span class="nsr-type">' + d.type + '</span></a>';
            }).join('');
        }
        r.classList.add('nsr-visible');
    };
    window.navSearchKey = function (e) {
        if (e.key === 'Escape') {
            var inp = document.getElementById('nav-search-input');
            inp.value = ''; runNavSearch(''); inp.blur();
        }
        if (e.key === 'Enter') {
            var q = e.target.value.trim();
            if (!q) return;
            var match = searchData.find(function (d) {
                return d.name.toLowerCase().indexOf(q.toLowerCase()) > -1 || d.tags.toLowerCase().indexOf(q.toLowerCase()) > -1;
            });
            if (match) window.location.href = match.url;
        }
    };
    document.addEventListener('click', function (e) {
        var wrap = document.querySelector('.nav-search-wrap');
        if (wrap && !wrap.contains(e.target)) {
            var r = document.getElementById('nav-search-results');
            if (r) { r.classList.remove('nsr-visible'); r.innerHTML = ''; }
            var inp = document.getElementById('nav-search-input');
            if (inp) { inp.value = ''; }
        }
    });
})();


// ── BLOCK 5: Homepage mobile section reorder ──
(function () {
    if (window.innerWidth > 768) return;
    if (!document.body.classList.contains('template-index')) return;

    var emailSec  = document.getElementById('shopify-section-email-signup');
    var shopAll   = document.getElementById('shopify-section-lifestyle-shop-all');
    if (emailSec && shopAll) {
        // Move lifestyle-shop-all to appear after email signup on mobile
        emailSec.parentNode.insertBefore(shopAll, emailSec.nextSibling);
    }
})();